import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, FormControlLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Edit, Delete, Add, Close, Phone } from '@material-ui/icons'
import { 
    Button, 
    TextField,
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableRow, 
    TableHead, 
    RadioGroup, 
    Radio, 
    Checkbox, 
    IconButton, 
    Select, 
    InputLabel, 
    MenuItem 
} from '@material-ui/core' 

export const StyledClose = styled(Close)`
  color: white; 
  font-size: 20px;
`
export const StyledIconButton = styled(IconButton)`
  display: flex;
  width: 35.994px;
  height: 35.994px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
`
export const StyledIconButtonWhite = styled(IconButton)`
  display: flex;
  width: 35.994px;
  height: 35.994px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  color: white!important;
  
  &.MuiButtonBase-root {
    color: white!important;
  }

  &.MuiIconButton-root {
    color: white!important;
  } 
`
export const Header = styled.div`
  display: flex;
  /* min-height so wrapped titles are not clipped at high browser zoom. */
  min-height: 100px;
  padding: 0 24px 0 24px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-bottom: 0.909px solid #E5E7EB;
`
export const Body = styled.div`
  display: flex;
  width: 100%;
  padding: 23.991px 23.992px 0 23.991px;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.991px;
  flex-shrink: 0;
  align-self: stretch;
`
export const NewCategoryBody = styled.div`
  display: flex;
  width: 100%;
  padding: 23.991px 23.992px 0 23.991px;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.991px;
  flex-shrink: 0;
  align-self: stretch;
`
export const DialogHeader = styled.div`
   max-height:1000px;
  .MuiDialogTitle-root {
   position: fixed;
    display: flex;
    height: 64px;
    background: ${theme.color.dialogBackground};
    align-items: center;
    justify-content: space-between;
    padding: 16px 36px;
  }

  .MuiIconButton-root {
    padding: 0;
  }
`

export const DialogHeaderBlue = styled.div`
   max-height:1000px;
  .MuiDialogTitle-root {
   position: fixed;
    display: flex;
    height: 64px;
    background: linear-gradient(90deg, #155DFC 0%, #1447E6 100%);
    align-items: center;
    justify-content: space-between;
    padding: 16px 36px;
  }

  .MuiIconButton-root {
    padding: 0;
  }
`
export const CategoryListTitleContainer = styled.div` 
  display: flex;
  margin-left: auto;
  min-height: 52.003px;
  justify-content: flex-start;
  align-items: center;
  gap: 11.989px;
`
export const CategoryListTitleSubContainer1 = styled.div` 
  display: flex;
  min-height: 52.003px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
`
export const CategoryListTitleSubContainer2 = styled.div` 
  display: flex;
  height: 52.003px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
`
export const HeaderTitle1 = styled.div`
  color: #101828;
  text-align: right;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
`
export const HeaderTitle2 = styled.div`
  color: #4C5564;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
`
export const ImageHeader = styled(Image)`
display: flex;
width: 40px;
height: 40px;
padding: 8px;
flex-direction: column;
align-items: flex-start;
flex-shrink: 0;
`
export const AddCategoryButton = styled(Button)`
  display: flex;
  padding: 14.534px 0 13.071px 0;
  justify-content: center;
  align-items: flex-start;
  gap: 7.295px;
  align-self: stretch;
  border-radius: 8px;
  border: 1.818px solid #D1D5DC;
  color: #155DFC;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
export const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
export const CategoryListItem = styled.div`
  display: flex; 
  padding: 16.903px 16.903px 0.909px 16.903px;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
`
export const CategoryListItemContainer = styled.div`
  display: flex;
  /* Category rows grow with wrapped text instead of clipping it. */
  min-height: 99.943px;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
`
export const CategoryListItemActions = styled.div`
  display: flex;
  height: 31.989px;
  align-items: flex-start;
  gap: 7.997px;
`
export const CategoryListItemContent = styled.div`
  display: flex;
  min-height: 99.943px;
  padding-right: 0;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 11.989px;
  flex: 1 0 0;
`
export const CategoryItemImageIcon = styled(Image)`
  width: 16px;
  height: 16px;
`
export const CategoryListItemTitle1 = styled.div`
  display: flex; 
  width: 100%;
  padding: 0 15.145px 0 692.116px;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #101828;
  text-align: right;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`
// New category
export const NewCatHeading3  = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #101828;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`
export const NewCatHeading4  = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
export const NewCatHeading5  = styled.div`
  display: flex;
  width: 100%;
  height: 20px;
  padding-left: 691.79px;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
export const NewCategoryContainer = styled.div`
  display: flex;
  width: 100%;
  padding-right: 0.009px;
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
export const NewCategoryContainerColumn = styled(NewCategoryContainer)`
  flex-direction: column;
`
export const NewSubCategoryContainer = styled.div`
  display: flex;
  width: 50%;
  min-width: 0;
  height: 69.801px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
`
export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.991px;
  flex-shrink: 0;
`
export const AllUsersCheckboxContainer = styled.div`
  display: flex;
  height: 45.795px;
  width: 100%;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E9D4FF;
  background: #FAF5FF;
  color: #59168B;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`

export const ViewerModeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const ViewerModeOption = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 0.909px solid ${p => p.selected ? '#4F46E5' : '#E5E7EB'};
  background: ${p => p.selected ? '#EEF2FF' : '#FFF'};
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  &:hover {
    border-color: ${p => p.selected ? '#4F46E5' : '#D1D5DC'};
  }
`

export const ViewerModeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const ViewerModeIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
`

export const ViewerModeTexts = styled.div`
  display: flex;
  flex-direction: column;
`

export const ViewerModeTitle = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: flex;
`

export const ViewerModeSubtitle = styled.div`
  color: #4C5564;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`
export const NewCategoryContainerActions = styled.div`
  border-top: 0.909px solid #E5E7EB;
  display: flex;
  padding: 8px 10px;
  padding-right: 749.517px;
  justify-content: flex-end;
  align-items: center;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
export const CategoryListItemIcon = styled.div<{ bg?: string }>`
  display: flex;
  width: 43.977px;
  height: 43.977px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${p => p.bg ?? '#E2E8F0'};
`
export const CategoryListItemSubContent = styled.div`
  display: flex;
  min-height: 99.943px;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.991px;
  flex: 1 0 0;
`
export const CategoryListItemTitle2 = styled.div`
  color: #4C5564;
  text-align: right;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* Descriptions are multi-line: keep the author's line breaks and spacing. */
  white-space: pre-wrap;
  word-break: break-word;
`
export const CategoryListUserContent = styled.div`
  display: flex;
  height: 35.98px;
  padding-right: 15.994px;
  align-items: flex-start;
  gap: 15.994px;
  align-self: stretch;
`
export const CategoryListUserItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.991px;
`
export const CategoryListUserItemTitle1 = styled.div`
  display: flex;
  height: 15.994px;
  padding-left: 303.338px;
  align-items: center;
  gap: 3.991px;
  align-self: stretch;
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
export const CategoryListUserItemTitle2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.991px;
  color: #4C5564;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`
export const CategoryListUserItem1 = styled.div`
  display: flex;
  height: 15.994px;
  align-items: center;
  gap: 3.991px;
  align-self: stretch;
  color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal; 
  font-weight: 400;
  line-height: 16px;
`
export const CategoryListUserItem2 = styled.div`
    color: #364153;
  text-align: right;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal; 
  font-weight: 400;
  line-height: 16px;
  display: flex;
  height: 16px;
  padding: 0 16px 0 16px;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
`